
import { Enums } from '@bode-canada/core';
import Typography from '@/ui-kit/components/typography';
import { TypographyProperty, TypographyType } from '@/ui-kit/components/typography/enums';
import { FormEventType } from '@/ui-kit/components/form/enums';
import { StyleFontWeightType } from '@/ui-kit/styles/enums';
import { LocationFormControlName } from '../forms/location/enums';
import LocationForm from '../forms/location';
import DatePeriodForm from '../forms/date-period';
import { DatePeriodMode, DatePeriodProperty } from '../forms/date-period/enums';
import BaseForm from '../mixins/BaseForm';
import { BaseFilterForm, BaseFilterProperty } from './enums';
import { FormProperty } from '../enums';

export default {
  name: 'BaseFilter',
  components: {
    Typography,
    LocationForm,
    DatePeriodForm,
  },
  mixins: [BaseForm],
  props: {
    [BaseFilterProperty.LocationFormTitle]: {
      type: String,
      default: '',
    },
    [BaseFilterProperty.DatePeriodFormTitle]: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      TypographyProperty,
      TypographyType,
      StyleFontWeightType,
      FormProperty,
      FormEventType,
      DatePeriodProperty,
      BaseFilterProperty,
    };
  },
  computed: {
    locationForm() {
      return this.getControl(BaseFilterForm.Location);
    },
    datePeriodForm() {
      return this.getControl(BaseFilterForm.DatePeriod);
    },
    province() {
      return this.locationForm.value[LocationFormControlName.Province];
    },
    datePeriodMode() {
      switch (this.province) {
        case Enums.ProvinceEnum.AB:
        case Enums.ProvinceEnum.ON:
          return DatePeriodMode.Shortest;
        case Enums.ProvinceEnum.BC:
        default:
          return DatePeriodMode.Shorten;
      }
    },
  },
};
